<!--
  Payment-failed page. Attractive, calm, and honest: a payment failing is
  routine, so the tone reassures (nothing was charged, the cart is safe) and the
  primary action is to try again rather than to leave.
-->
<div class="min-h-[78vh] flex items-center justify-center px-4 py-10 bg-[#faf8f5]">
  <div class="w-full max-w-md">

    <div class="bg-white rounded-3xl shadow-[0_10px_40px_-15px_rgba(96,11,11,0.25)] border border-gray-100 overflow-hidden">

      <!-- Header band -->
      <div class="bg-gradient-to-b from-[#600b0b] to-[#7a1414] px-6 pt-8 pb-10 text-center">
        <div class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-white/10 ring-1 ring-white/20">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
        </div>
        <h1 class="mt-4 text-xl font-bold text-white" style="font-family: 'Roboto Slab', serif;">Payment not completed</h1>
        <p class="mt-1 text-sm text-white/70">No money has been taken from your account.</p>
      </div>

      <!-- Body -->
      <div class="px-6 py-6">

        <!-- The reason, straight from the gateway -->
        <div class="rounded-xl bg-rose-50 border border-rose-100 px-4 py-3">
          <p class="text-sm text-rose-800 leading-relaxed">{{ reason }}</p>
        </div>

        <!-- Order details, when we have them -->
        <div *ngIf="orderReference || amount > 0" class="mt-5 space-y-2.5">
          <div *ngIf="orderReference" class="flex items-center justify-between text-sm">
            <span class="text-gray-500">Order</span>
            <span class="font-semibold text-gray-900 font-mono">{{ orderReference }}</span>
          </div>
          <div *ngIf="amount > 0" class="flex items-center justify-between text-sm">
            <span class="text-gray-500">Amount</span>
            <span class="font-semibold text-gray-900">&#8377;{{ amount | number:'1.2-2' }}</span>
          </div>
        </div>

        <!-- Reassurance -->
        <div class="mt-5 flex items-start gap-2.5 rounded-xl bg-green-50 border border-green-100 px-4 py-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="#15803d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 shrink-0">
            <path d="M20 6L9 17l-5-5"></path>
          </svg>
          <p class="text-xs text-green-800 leading-relaxed">
            Your cart and this order are saved. You can try the payment again — a new order
            is only created once the payment succeeds.
          </p>
        </div>

        <!-- Actions -->
        <div class="mt-6 space-y-2.5">
          <button (click)="retry()"
            class="w-full bg-[#600b0b] text-white py-3.5 rounded-full font-semibold text-sm hover:bg-[#7a1414] transition-colors">
            Try payment again &rarr;
          </button>
          <button (click)="backToCart()"
            class="w-full bg-white text-gray-600 border border-gray-200 py-3 rounded-full font-medium text-sm hover:border-gray-300 hover:text-gray-800 transition-colors">
            Back to cart
          </button>
        </div>

        <!-- Support -->
        <p class="mt-5 text-center text-[11px] text-gray-400 leading-relaxed">
          Charged but the order still shows unpaid? Email
          <a href="mailto:care@mahatta.com" class="text-[#600b0b] hover:underline">care&#64;mahatta.com</a>
          <ng-container *ngIf="paymentId"> with reference <span class="font-mono">{{ paymentId }}</span></ng-container>
          and we will sort it out. Any amount debited on a failed payment is refunded
          automatically by your bank.
        </p>
      </div>
    </div>

    <p class="mt-4 text-center text-[11px] text-gray-400">Secured by Razorpay &bull; MahattaArt</p>
  </div>
</div>
